import {MentalLayerSet} from "./MentalReelAreaView";
import {TimelineLite} from "gsap";

export class MentalSymbolName {
    public static M1: string = "M1";
    public static M2: string = "M2";
    public static M3: string = "M3";
    public static M4: string = "M4";
    public static M5: string = "M5";
    public static L1: string = "L1";
    public static L2: string = "L2";
    public static L3: string = "L3";
    public static L4: string = "L4";
    public static L5: string = "L5";
    public static W: string = "W";
    public static W3: string = "W3"; // xNudge stack symbol
    public static S: string = "S";
    public static S2: string = "S2";
    public static D: string = "D"; // dead symbol
    public static DG: string = "DG"; // dead symbol gold version
}

export enum MentalSymbolStates {
    NONE = "none",
    NORMAL = "normal",
    SPIN = "spin",
    LANDING = "landing",
    ONE_FORTY_EIGHT = "148",
    ONE_THIRTY_TWO = "132",
    ONE_HUNDRED_EIGHTEEN = "118",
    NINETY_NINE = "99",
    EIGHTY_FOUR = "84",
    SEVENTY_FOUR = "74",
    SIXTY_SIX = "66",
    SIXTY = "60",
    FIFTY_SIX = "56",
    FIFTY = "50",
    FORTY_FIVE = "45",
    FORTY = "40",
    THIRTY_TWO = "32",
    TWENTY_SIX = "26",
    WIN = "win",
    NO_WIN = "no_win",
    NO_WIN_DARK = "no_win_dark",
    STANDARD_FS_ANTICIPATION = "standard_fs_anticipation",
    COOL_FS_ANTICIPATION = "cool_fs_anticipation",
    SUPER_FS_ANTICIPATION = "super_fs_anticipation",
}

export interface MentalSymbol {
    symbolName: string;
    layerSet: MentalLayerSet
    position: PIXI.ObservablePoint;
    currentTextureState: PIXI.Sprite | PIXI.spine.Spine;
    currentSymbolHeight: number;

    clear(): void;

    setState(state: MentalSymbolStates): void;

    getWinAnimation(): TimelineLite;

    getNoWinAnimation(): TimelineLite;

    getToggleAnimation(): TimelineLite;

    getShakeAnimation(): TimelineLite;
}